import React, { Component, Fragment } from 'react'
import { connect } from 'react-redux'
import styled, { css } from 'styled-components'
import DataTable from '../../components/Table/Table'
import Header from '../../components/Header'
import Modal from '../../components/Modal'
import Sidebar from '../../components/Sidebar'
import Switch from '../../components/Switch'
import ResponsiblesContent from '../../components/ResponsiblesContent'
import { DownloadButton } from '../../components/Form'
import { Grid, Content } from '../../components/Layout'
import { productMapActions } from '../../actions'
import { pxToRem, color, captions, productFullName } from '../../utils'
import statusSuccess from '../../assets/icons/status-success.svg'
import statusDanger from '../../assets/icons/status-danger.svg'
import iconExcel from '../../assets/icons/iconExcel.svg'
import ReactTooltip from 'react-tooltip'
import sortBy from 'array-sort-by'
import ContentHeader from '../../components/ContentHeader'
import dateToBrFormat from '../../utils/dateToBrFormat'
import { ProductMapModal, UpdateAmountModal } from '../../components/ProductModal'
import editIcon from '../../assets/icons/edit.svg'

const WrapperStatus = styled.div`
  width: 20px;
  height: 20px;
  margin: auto;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  position: relative;

  img {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;

    margin: auto;
    width: 14px;
  }

  ${({ type }) => {
    return `background: ${type === 's' ? color.danger : color.success}`
  }};
`

const ProductMapLink = styled.a`
  color: ${color.secondary};
  text-transform: uppercase;
  text-decoration: underline;
  font-weight: bold;
  cursor: pointer;
`

const CaptionsArea = styled.div`
  margin: 20px 0 0 0;
  font-size: ${pxToRem(14)};
  width: 100%;
`

const WrapperActions = styled.div`
  display: flex;
  align-items: center;
`

const Action = styled.img`
  width: ${pxToRem('15px')};
  margin: 5px;
  display: inline-block;
  cursor: pointer;
`

const CaptionItem = props => {
  return (
    <div>
      <strong>{props.caption}: </strong>{props.meaning}
    </div>
  )
}

const plural = (text, ...args) => {
  const [qtd = '--'] = args;

  const formattedText = text.map((item, index) => {
    const singular = index === 0;

    switch (true) {
      case qtd === 0:
        return singular ? 'Não existem ' : item;
      case qtd === 1:
        return singular ? `Existe no total ${qtd} ${item}` : 'produto utilizado nesta área';
      default:
        return singular ? `Existem no total ${qtd} ${item}` : item;
    }
  });

  return formattedText;
}


const Wrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  margin-bottom: ${pxToRem(10)};
`

const WrapperDownload = styled.div`
  display: block;
  text-align: right;
  width: 100%;

  button {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    img {
      margin-right: 2px;
      max-width: 14px;
      max-height: 14px;
    }
  padding-left: 0;
  padding-right: 0;
  }
  span {
    font-weight: bold;
  }
`

const columns = {
  id: {
    hide: true
  },
  name: {
    label: 'Produto',
    sortable: true,
    align: 'left',
    width: pxToRem(150)
  },
  provider: {
    label: 'Fornecedor',
    sortable: true,
    align: 'left',
    width: pxToRem(50)
  },
  kinds_list: {
    label: 'Id. de Perigo',
    sortable: false,
    align: 'left',
    width: pxToRem(50)
  },
  cabinets: {
    label: 'Armários',
    sortable: false,
    align: 'left',
    width: pxToRem(50)
  },
  supervisories_code: {
    label: 'Controlados',
    sortable: false,
    align: 'left',
    width: pxToRem(50)
  },
  amount_measure: {
    label: 'Quantidade',
    sortable: false,
    align: 'left',
    width: pxToRem(50),
  },
  has_incompatibility: {
    label: 'Incompatibilidade',
    sortable: false,
    width: pxToRem(50),
    align: 'center',
    sort: ({ mapedColumns = [], sortByColumn, reverseSort }) => {
      return sortBy(mapedColumns, item => {
        return reverseSort ? `desc:${item[sortByColumn].value}` : item[sortByColumn].value
      })
    },
    CellComponent: ({ value: column }) => {
      let item = {}

      if (!column.value) {
        item = {
          icon: statusSuccess,
          tooltip: column.label,
          value: 'n'
        }
      } else {
        item = {
          icon: statusDanger,
          tooltip: column.label,
          value: 's'
        }
      }

      return (
        <WrapperStatus
          data-tip={`Este produto é incompatível com: ${item.tooltip}`}
          type={`${item.value}`}
        >
          <span aria-label={item.value}>
            <img src={item.icon} alt={item.value} />
            <ReactTooltip html place="bottom" type="light" effect="solid" className="exo-gpq-tooltip" />
          </span>
        </WrapperStatus>
      )
    }
  },
  loadingStatus: {
    hide: true,
    realValue: true
  },
  active: {
    label: 'Ativo',
    width: pxToRem(20),
    sortable: true,
    realValue: true,
    align: 'center',
    CellComponent: ({ value, row }) => {
      const mapStateToProps = state => ({
        areaId: state.auth.areaId
      })

      const mapDispatchToProps = dispatch => {
        return {
          changeProductMapStatus: ({ id, active, areaId }) => {
            return dispatch(productMapActions.changeProductMapStatus({ id, active, areaId }))
          }
        }
      }

      const SwitchConnected = connect(mapStateToProps, mapDispatchToProps)(({ changeProductMapStatus, areaId }) => {
        return (
          <div style={{ textAlign: 'center' }}>
            <Switch
              id={`product-${row.id}`}
              checked={value}
              loading={!!row.loadingStatus}
              disabled={!!row.loadingStatus}
              onChange={e => {
                const target = e.target
                const value = target.type === 'checkbox' ? target.checked : target.value

                changeProductMapStatus({ id: row.id, active: !!value, areaId }).catch(error => {
                  row.changeStatusError()
                })
              }}
            />
          </div>
        )
      })
      return <SwitchConnected />
    }
  }
}

class ChemicalMap extends Component {
  constructor(props) {
    super(props)
    this.state = {
      openProductMapModal: false,
      openUpdateAmountModal: false,
      debounce: undefined,
      productMapStatusError: false
    }
  }

  componentDidMount() {
    this.props.fetchProductMaps(this.props.areaId)
  }

  closeModal = () => {
    this.setState(state => ({
      openProductMapModal: false
    }))
  }

  closeUpdateAmountModalModal = () => {
    this.setState(state => ({
      openUpdateAmountModal: false
    }))
  }

  closeProductMapStatusError = () => {
    this.setState(state => ({
      productMapStatusError: false
    }))
  }

  openProductMapStatusError = () => {
    this.setState(state => ({
      productMapStatusError: true
    }))
  }

  openModal = (e, id) => {
    e.preventDefault()
    this.props.fetchProductMap(id)

    this.setState(state => ({
      openProductMapModal: true,
      productMapId: id
    }))
  }

  openModalUpdateAmount = (e, id) => {
    e.preventDefault()
    this.props.fetchProductAmount(id, this.props.areaId)

    this.setState(state => ({
      openUpdateAmountModal: true
    }))
  }

  handledColumns = columns => {
    const { areaId } = this.props
    const newColumns = { ...columns }

    if (areaId === 'all') {
      delete newColumns.cabinets
      delete newColumns.active
      delete newColumns.amount_measure
    }

    return newColumns
  }

  onChangeRowsPerPage = (rowsPerPage, currentPage = 1) => {
    if (!!this.props.searchText) {
      this.props.fetchSearch(this.props.searchText, this.props.areaId, currentPage, rowsPerPage, this.props.pagination.order_by, this.props.pagination.order ? "asc" : "desc")
    } else {
      this.props.fetchProductMaps(this.props.areaId, currentPage, rowsPerPage, this.props.pagination.order_by, this.props.pagination.order ? "asc" : "desc")
    }
  }

  onChangePage = (newPage, rowsPerPage) => {
    if (!!this.props.searchText) {
      this.props.fetchSearch(this.props.searchText, this.props.areaId, newPage, rowsPerPage, this.props.pagination.order_by, this.props.pagination.order ? "asc" : "desc")
    } else {
      this.props.fetchProductMaps(this.props.areaId, newPage, rowsPerPage, this.props.pagination.order_by, this.props.pagination.order ? "asc" : "desc")
    }
  }

  onChangeOrderBy = (orderBy, order, currentPage = 1, rowsPerPage = 10) => {
    if (orderBy === "has_incompatibility") orderBy = "incompatibility"
    if (!!this.props.searchText) {
      this.props.fetchSearch(this.props.searchText, this.props.areaId, currentPage, rowsPerPage, orderBy, order)
    } else {
      this.props.fetchProductMaps(this.props.areaId, currentPage, rowsPerPage, orderBy, order)
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.areaId && prevProps.areaId !== this.props.areaId) {
      const debounce = setTimeout(() => {
        this.props.fetchSearch(this.props.searchText, this.props.areaId)
      }, 400)

      this.setState(state => {
        clearTimeout(state.debounce)
        return { debounce }
      })
    }
  }

  componentWillUpdate({ searchText = '' }) {
    if (searchText !== this.props.searchText) {
      const debounce = setTimeout(() => {
        this.props.fetchSearch(searchText, this.props.areaId)
      }, 400)

      this.setState(state => {
        clearTimeout(state.debounce)
        return { debounce }
      })
    }

    return true
  }

  render() {
    const {
      changeStatusDownloadError,
      fetchProductMaps,
      pagination,
      fetch_errors,
      fetching,
      last_update,
      menuItems = [],
      productMaps,
      router,
      total_records,
      canChangeStatus,
      canUpdateAmount,
      areaId,
      can_change_area,
      loadingDownload
    } = this.props

    const {
      closeModal,
      closeProductMapStatusError,
      closeUpdateAmountModalModal,
      handledColumns,
      onChangeOrderBy,
      onChangePage,
      onChangeRowsPerPage,
      openModal,
      openModalUpdateAmount,
      openProductMapStatusError,
    } = this

    const { openProductMapModal, productMapId, productMapStatusError, openUpdateAmountModal } = this.state

    const CellComponent = ({ name, value, row, ...rest }) => {
      return (
        <ProductMapLink {...rest} onClick={e => openModal(e, row.id)}>
          {value}
        </ProductMapLink>
      )
    }

    columns['name'] = {
      ...columns['name'],
      CellComponent
    }

    const amountMeasureCellComponent = ({value, row}) => {
      if (row.active)
        return (
          <WrapperActions>
            {value}
            {canUpdateAmount && <Action src={editIcon} onClick={e => openModalUpdateAmount(e, row.id)}/>}
          </WrapperActions>
        )
      return '---'
    }

    if (process.env.REACT_APP_USE_PRODUCT_AREA_AMOUNT === 'y') {
      columns['amount_measure'] = {
        ...columns['amount_measure'],
        CellComponent: amountMeasureCellComponent
      }
    } else {
      delete columns['amount_measure']
    }

    columns['changeStatusError'] = {
      hide: true,
      realValue: true,
      callback: openProductMapStatusError
    }

    if (!canChangeStatus) {
      delete columns['active']
    }

    return (
      <Fragment>
        <Grid>
          <Header search router={router} />
          <Sidebar menuItems={menuItems} router={router} />
          <Content scapeSearch>
            <ContentHeader
              title="Produtos Químicos"
              subtitle={plural`Existe no total ${total_records} produtos utilizados nesta área`}
              last_update={dateToBrFormat(new Date(last_update))}
            >
            </ContentHeader>
            <Wrapper>
              <CaptionsArea>
                {
                  (captions || []).map(caption => (
                    <CaptionItem
                      caption={caption.abbreviation}
                      meaning={caption.meaning}
                    />
                  ))
                }
              </CaptionsArea>

              <WrapperDownload>
                <DownloadButton
                  loading={loadingDownload}
                  onClick={e => {
                    this.props.fetchRelationProductDownload(
                      this.props.searchText,
                      areaId,
                      can_change_area
                    )
                  }}
                >
                  <img src={iconExcel} />
                  <span>Exportar para excel</span>
                </DownloadButton>
              </WrapperDownload>
            </Wrapper>

            <DataTable
              loading={fetching.productMaps}
              error={fetch_errors.productMaps}
              fetchData={fetchProductMaps}
              onChangePage={(newPage, rowsPerPage, orderBy, order) =>
                onChangePage(newPage, rowsPerPage, orderBy, order)
              }
              onChangeRowsPerPage={(rowsPerPage, currentPage, orderBy, order) =>
                onChangeRowsPerPage(rowsPerPage, currentPage, orderBy, order)
              }
              onChangeOrderBy={(orderBy, order, currentPage, rowsPerPage) =>
                onChangeOrderBy(orderBy, order, currentPage, rowsPerPage)
              }
              columns={handledColumns(columns)}
              height={'55vh'}
              width={1100}
              data={productMaps.map(item => {
                item.changeStatusError = openProductMapStatusError
                return {
                  ...item,
                  name: productFullName(item)
                }
              })}
              pagination={pagination || {}}
              defaultSort={{ key: 'name', reverse: false }}
            />
            <ResponsiblesContent />
          </Content>
        </Grid>

        <Modal
          safeContent={false}
          loading={false}
          open={productMapStatusError}
          size={'small'}
          error={true}
          errorMessage={'Falha ao alterar o status do produto'}
          closeMethod={closeProductMapStatusError}
        />

        <Modal
          safeContent={false}
          loading={false}
          open={fetch_errors.download}
          size={'small'}
          error={true}
          errorMessage={'Falha ao exportar o arquivo'}
          closeMethod={changeStatusDownloadError}
        />

        <UpdateAmountModal open={openUpdateAmountModal} closeModal={closeUpdateAmountModalModal}/>

        <ProductMapModal
          open={openProductMapModal}
          productId={productMapId}
          closeModal={closeModal}
        />
      </Fragment>
    )
  }
}

const mapStateToProps = state => ({
  canChangeStatus: state.productMap.canChangeStatus,
  canUpdateAmount: state.productMap.canUpdateAmount,
  productMaps: state.productMap.items,
  total_records: state.productMap.total_records,
  last_update: state.productMap.last_update,
  productMap: state.productMap.productMap,
  pagination: state.productMap.pagination,
  fetching: state.productMap.fetching,
  fetch_errors: state.productMap.fetch_errors,
  searchText: state.search.searchText,
  areaId: state.auth.areaId,
  permissions: state.auth.permissions,
  can_change_area: state.auth.canChangeArea,
  loadingDownload: state.productMap.fetching.download
})

const mapDispatchToProps = dispatch => {
  return {
    fetchProductMaps: (areaId, page, rowsPerPage, orderBy, order) => {
      dispatch(productMapActions.fetchProductMaps(areaId, page, rowsPerPage, orderBy, order))
    },
    fetchProductMap: (id, areaId) => {
      dispatch(productMapActions.fetchProductMap(id, areaId))
    },
    fetchProductAmount: (id, areaId) => {
      dispatch(productMapActions.fetchProductAmount(id, areaId))
    },
    fetchSearch: (searchText, areaId, page, rowsPerPage, orderBy, order) => {
      dispatch(productMapActions.fetchSearch(searchText, areaId, page, rowsPerPage, orderBy, order))
    },
    changeProductMapStatus: ({ id, active, areaId }) => {
      dispatch(productMapActions.changeProductMapStatus({ id, active, areaId }))
    },
    fetchRelationProductDownload: (searchText, areaId, can_change_area) => {
      dispatch(productMapActions.fetchRelationProductDownload(searchText, areaId, can_change_area))
    },
    changeStatusDownloadError: () => {
      dispatch(productMapActions.changeStatusDownloadError())
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(ChemicalMap)



// WEBPACK FOOTER //
// ./src/containers/ProductMap/ChemicalMap.js